// @flow

const pushIf = (hidden: boolean, name: string): Array<string> => (
    hidden ? [name] : []
);

export default pushIf;
